module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _vm._v(" "), _c('title', [_vm._v("Remembering Farley")]), _vm._v(" "), _c('link', {
    attrs: {
      "href": "style.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_vm._v("The very first wireless communication device, of\ncourse, was Mom. When I was an infant, she could hear\nthe faintest peep from the opposite end of the house. Now\nthat I’m an adult, she can hear the faintest peep from the\nopposite end of town or, for that matter, the country.")]), _vm._v(" "), _c('div', {
    staticClass: "float_img_left_1-4_1"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/P-008-1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a1d8f806","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mom014.vue
// module id = 93
// module chunks = 0